import { Experiment, ExperimentTreatmentValue } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';

import { useExperimentTreatmentWithoutReporting } from './selectors';
import { useReportExperimentTreatmentCallback } from './useReportExperimentTreatmentCallback';

interface UseShouldUseExperimentTreatmentProps {
  readonly experiment: Experiment;
  readonly treatments: ExperimentTreatmentValue[];
  readonly condition?: boolean;
  readonly reportExperiment?: boolean;
}

type UseShouldUseExperimentTreatment = (props: UseShouldUseExperimentTreatmentProps) => boolean;
export const useShouldUseExperimentTreatment: UseShouldUseExperimentTreatment = ({
  experiment,
  treatments,
  condition = true,
  reportExperiment = true,
}) => {
  const treatment = useExperimentTreatmentWithoutReporting(experiment);
  const shouldUseExperimentTreatment = treatments.includes(treatment) && condition;
  const reportExperimentTreatmentCallback = useReportExperimentTreatmentCallback(experiment, treatment);

  useEffect(() => {
    if (condition && reportExperiment) {
      reportExperimentTreatmentCallback();
    }
  }, [reportExperimentTreatmentCallback, condition, reportExperiment]);

  return shouldUseExperimentTreatment;
};
